<template>
  <div>
    <draggable class="d-flex" :list="amaActivites" @end="movingSections">
      <Section v-for="(section, index) in amaActivites" :key="section.id" :title="section.title" :tasks="section.tasks" :sectionIndex="index" @change="movingTasks" />
    </draggable>
  </div>
</template>

<script>

import Section from './/Section.vue'
import draggable from 'vuedraggable'
import { mapGetters } from 'vuex'

export default {
  components: {
    Section,
    draggable
  },
  computed: {
    ...mapGetters(['amaActivites']),
  },
  methods: {
    movingSections: function(){
      this.$store.dispatch('saveSections', { args: this.amaActivites })
    },
    movingTasks: function(){
      this.$store.dispatch('saveSections', { args: this.amaActivites })
    },
    getActivite() {
      let args = {
        id: 1264
      };

      this.$store.dispatch("getAmaActivites", {args});
    },
  },
  mounted() {
    this.getActivite();
  }
};


// import Section from './Section.vue'
// import draggable from 'vuedraggable'
// import { mapGetters } from 'vuex'
// import _ from "lodash";

// export default {
//   components: {
//     Section,
//     draggable,
//   },
//   computed: {
//     ...mapGetters(['amaActivites']),

//     activites: function() {
           
//             let toDo = [];
//             let enCours = [];
//             let termine = [];
//             let gArray = {};

//             _.forEach(this.amaActivites,function(items){
//                 if(items.activites.length>0){
//                     _.forEach(items.activites, function(item){   
//                         if(item.statut==="En cours"){
//                             enCours.push(items);
//                         }else if(item.statut==="Terminé"){
//                             termine.push(items);
//                         }else {
//                             toDo.push(items);
//                         }
//                     })
//                 }else{
//                     toDo.push(items);
//                 }

//             });

//             this.waiting =  toDo ;
//             this.doing =  enCours ;
//             this.done =  termine ;
//             return gArray;
//     },

//     enCours:  {
//       get: function (){
//             let toDo = [];
//             let enCours = [];
//             let termine = [];
//             let gArray = [];

//             _.forEach(this.amaActivites,function(items){
//                 if(items.activites.length>0){
//                     _.forEach(items.activites, function(item){   
//                         if(item.statut==="En cours"){
//                             enCours.push(items);
//                         }else if(item.statut==="Terminé"){
//                             termine.push(items);
//                         }else {
//                             toDo.push(items);
//                         }
//                     })
//                 }else{
//                     toDo.push(items);
//                 }

//             });

//             gArray.push({id: 1, title: this.$i18n.t('message.toDo'),tasks: toDo});
// //            gArray.push({id: 2, title: this.$i18n.t('message.doing'),tasks: enCours});
// //            gArray.push({id: 3, title: this.$i18n.t('message.cloture'),tasks: termine});
//             return gArray;
//       },
//       set: function(data){
//           this.amaActivites = data;
//       }
//     },
//       classList(){
//       const classList = ['task']
//       return classList;
//     },
//   },
//    data() {
//       return {
//         enabled: true,
//         waiting: [],
//         doing: [],
//         done: [],
//         dragging: false,
//       }
//     },
//   methods: {
//     add: function() {
//       this.list.push({ name: "Juan" });
//     },
//     replace: function() {
//       this.list = [{ name: "Edgard" }];
//     },
//     clone: function(el) {
//       return {
//         name: el.name + " cloned"
//       };
//     },
//     log: function(evt) {
//       window.console.log(evt);
//     }
//   },
//   mounted() {
//     this.getActivite();
//   }
// };
 </script>
<style>

.d-flex {
  display: flex;
}

/* Section Style */
.addSection {
  margin: 0 10px;
  display: inline-block;
  flex-direction: column;
  align-items: flex-start;
  width: 300px;
}

.deleteSection {
  position: absolute;
  top: 3px;
  right: 10px;
  font-size: 25px;
}
.addSection1 {
  position: absolute;
  top: 3px;
  right: 50%;
  font-size: 25px;
}
.deleteSection:hover {
  opacity: 0.8;
  cursor: pointer;
}

.section {
  margin: 0 5px auto;
  position: relative;
  display: inline-block;
  flex-direction: column;
  align-items: flex-start;
  width: 350px;
  background-color: #e0e0e0a6;
  border-radius: 10px;
  padding: 15px;
  border: solid rgb(243, 243, 243) 1px;
  color: gray;
  vertical-align: top;
}

.section-title {
  font-size: 25px;
  font-weight: bold;
}
/* Section Style fin */


/* Task Style */
.task {
  margin: 10px 0;
  position: relative;
  /* display: flex; */
  padding: 20px 15px;
  background-color: rgba(255, 255, 255, 0.712);
  border-radius: 10px;
  width: 320px;
  cursor: pointer;
}

.delete-button {
  position: absolute;
  top: 5px;
  right: 5px;
  font-size: 20px;
  cursor: pointer;
  border-radius: 8px;
  border: none;
  background-color: #ca7da1;
  color: white;
  margin: 5px;
}

.delete-button:hover{
  opacity: 0.8;
  cursor: pointer;
}

.edit-button{
  position: absolute;
  padding: 5px 8px;
  bottom: 5px;
  right: 5px;
  font-size: 15px;
  cursor: pointer;
  border-radius: 10px;
  border: none;
  background-color: rgb(131, 127, 127);
  color: white;
  margin: 5px;
}

.edit-button:hover{
  opacity: 0.8;
  cursor: pointer;
}

.content {
  font-size: 20px;
}
/* Task Style fin */


/* Section & Task Style */
.input-text {
  padding: 15px;
  background-color: rgba(204, 204, 204, 0.507);
  border-radius: 10px;
  cursor: pointer;
  border: solid rgb(243, 243, 243) 1px;
  font-weight: 700;
  font-size: 20px;
  color: #242424;
  width: 260px;
}
.input-task{
  margin-top: 30px;
  background-color: rgba(255, 255, 255, 0);
  border-radius: 10px;
  cursor: pointer;
  border: solid rgba(255, 255, 255, 0) 1px;
  font-weight: 700;
  font-size: 20px;
  color: #242424;
  width: 100%;
}
.input-text:focus {
  outline: 0;
}
.input-task:focus {
  outline: 0;
}

.active .input-text {
  background-color: rgba(255, 255, 255, 0.712);
}

.add-button {
  margin-top: 15px;
  padding: 15px;
  background-color: rgb(131, 127, 127);
  border: none;
  border-radius: 10px;
  font-weight: 700;
  font-size: 20px;
  color: #fff;
  width: 290px;
}

.add-button:hover {
  opacity: 0.8;
  cursor: pointer;
}
</style>